import React from 'react';
import PropTypes from 'prop-types';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';

const ChatBubble = ({ type, children }) => {
    const Icon = type === 'user' ? PersonRoundedIcon : SmartToyRoundedIcon;

    return (
        <div className={`ChatBubble ${type}`}>
            <div className={`icon ${type}`}><Icon /></div>
            <p>{children}</p>
        </div>
    );
};

ChatBubble.propTypes = {
    type: PropTypes.oneOf(['user', 'bot']).isRequired,
    children: PropTypes.node.isRequired
};

export default ChatBubble;
